// Does this package option carry admin-uploaded artwork? Paperclip serves
// `/images/original/missing.png` when it does not, and that placeholder is the
// ONE thing every card and every layout rule must agree on: offeredOptions
// decides whether an option is showable, packageGridLayout whether it is a
// featured card, and the cards whether to draw the artwork or Package_Blue.
export const hasArtwork = (option) => !!option?.imageUrl && !option.imageUrl.includes('missing.png');

export default hasArtwork;
